import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

export interface ShaderReplaceChoice {
  label: string
  onSelect: () => void
}

interface ShaderReplaceDialogProps {
  open: boolean
  title: string
  description: string
  /** Primary choice first; every choice closes the dialog. */
  choices: ShaderReplaceChoice[]
  onCancel: () => void
}

/** Asks before an action would throw away code the user wrote or edited. */
export function ShaderReplaceDialog({ open, title, description, choices, onCancel }: ShaderReplaceDialogProps) {
  const [primary, ...rest] = choices
  return (
    <AlertDialog open={open} onOpenChange={(next) => { if (!next) onCancel() }}>
      <AlertDialogContent className="sm:max-w-[425px]">
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          {rest.map((choice) => (
            <AlertDialogAction key={choice.label} onClick={choice.onSelect} className="border border-border bg-background text-foreground hover:bg-accent">
              {choice.label}
            </AlertDialogAction>
          ))}
          {primary && <AlertDialogAction onClick={primary.onSelect}>{primary.label}</AlertDialogAction>}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
